// extracted by mini-css-extract-plugin
export default {"container":"Gr-z","heading":"Hr-z","text":"Ir-z","info":"Jr-z","link":"Kr-z","fullMaxWidth":"Lr-z"};